// extracted by mini-css-extract-plugin
var _1 = "Bold-wd7YV";
var _2 = "Medium-t2JTy";
var _3 = "Razzmatazz-_7szt";
var _4 = "SemiBold-r_eBQ";
export { _1 as "Bold", _2 as "Medium", _3 as "Razzmatazz", _4 as "SemiBold" }
